import axios from 'axios'
import { toast } from 'react-toastify'

interface FormFields {
  [key: string]: string
}

const hubspotSubmit = (data: any, FormEndpoint: string) => {
  try {
    let completeData: FormFields = { product_name: window.location.href, ...data }

    // Construct the HS fields for submission
    const payload = Object.keys(completeData).map((key: string) => {
      return { name: key, value: completeData[key] }
    })

    console.log(JSON.stringify({ fields: payload }))
    const response = axios.post(FormEndpoint, JSON.stringify({ fields: payload }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  } catch (err) {
    toast.error('Error submitting form - Please call us on 02 9233 8633')
    return
  }
}

export { hubspotSubmit }
